module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./VideoGalleryView.js"));
	}, "GuangView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=GuangView!./src/pages/Shop/Guang/VideoGallery/VideoGalleryView.js
// module id = 1818
// module chunks = 367